module.exports = __webpack_public_path__ + "static/img/checkmark.b2ce439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkmark.png
// module id = WCFE
// module chunks = 1